/**
 * Single source of truth for the privacy-policy version.
 *
 * Bump the version string whenever a MATERIAL change lands in
 * `pages/PrivacyPage.js` (new cookie category, new third-party processor,
 * new legal basis, etc.). Cosmetic edits do NOT need a bump.
 *
 * Consent is stored alongside this version — a bump auto-invalidates
 * every existing visitor's consent, causing the banner to reappear so
 * they can re-consent to the updated terms (GDPR-audit friendly).
 *
 * Convention: `YYYY-MM-DD` matching the "Last updated" date on the
 * PrivacyPage.
 */
export const POLICY_VERSION = '2026-02-20';
